import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { UserProfitReport } from "@src/components/modules/reports/user-profit-report";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { withCan } from "@src/utils/components/permissions";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/user-profit",
  title: () => t`User Profit`,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <UserProfitReport />
    </DemoModule>
  </MainLayout>
);

const RouteComponent = withCan(
  { do: ["utilizationReportProfit_query_all"] },
  Page,
);

export const Route = createFileRoute("/reports/user-profit")({
  component: RouteComponent,
});
